import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Proof from './components/Proof';
import Services from './components/Services';
import StyleMarquee from './components/StyleMarquee';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Location from './components/Location';
import Footer from './components/Footer';
import StickyActions from './components/StickyActions';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Proof />
        <Services />
        <StyleMarquee />
        <Portfolio />
        <Testimonials />
        <About />
        <Location />
      </main>
      <Footer />
      <StickyActions />
    </div>
  );
}

export default App;
